/**
 * Le due lingue del prodotto. Stesse del CHECK su `users.preferred_language`:
 * aggiungerne una qui senza toccare quel vincolo fa fallire la scrittura.
 *
 * Il default è l'inglese, come `i18n.ts` (lingua iniziale e `fallbackLng`) e
 * come il default della colonna: un utente nuovo riceve le mail nella stessa
 * lingua in cui gli si presenta l'interfaccia.
 */
export type AppLanguage = 'it' | 'en';

export const APP_LANGUAGES: AppLanguage[] = ['it', 'en'];

export const DEFAULT_LANGUAGE: AppLanguage = 'en';

/** Nomi delle lingue nella lingua stessa: non si traducono. */
export const LANGUAGE_LABELS: Record<AppLanguage, string> = {
  it: 'Italiano',
  en: 'English',
};

export const isAppLanguage = (value: unknown): value is AppLanguage =>
  typeof value === 'string' && (APP_LANGUAGES as string[]).includes(value);
